import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import * as leaflet from 'leaflet';
import { useMapLoadedStatus } from 'hooks/useMapLoadedStatus';
import { INITIAL_MAP_ZOOM } from 'constants/profile';
import location from '../../../../assets/img/location.svg';
import { MarkerInterface } from '../types';
import * as Styled from './styled';

type ICenterControl = {
  markers: MarkerInterface[];
};

export const CenterControl = ({ markers }: ICenterControl) => {
  const map = useMap();
  const { dispatchZoomLevel } = useMapLoadedStatus();

  const handleClick = () => {
    markers.forEach(({ coordinates }) => {
      map.setView(leaflet.latLng(coordinates[0], coordinates[1]), INITIAL_MAP_ZOOM);
    });
  };
  const updateZoomLevels = () => {
    const zoomLevel = map.getZoom();

    dispatchZoomLevel(zoomLevel);
  };

  useEffect(() => {
    updateZoomLevels();

    map.on('zoomend', updateZoomLevels);

    return () => {
      map.off('zoomend', updateZoomLevels);
    };
  }, [map]);

  return (
    <Styled.CenterButton type="button" onClick={handleClick} data-testid="button-center-control">
      <img src={location} alt="location" />
    </Styled.CenterButton>
  );
};
